export enum ApiTagsEnum {
  GET_FILTERED_LEAGUES = 'GET_FILTERED_LEAGUES',
  GET_FILTERED_MEMBERS = 'GET_FILTERED_MEMBERS',
  GET_LEAGUE_BY_ID = 'GET_LEAGUE_BY_ID',
  GET_LEAGUE_LEADERBOARD = 'GET_LEAGUE_LEADERBOARD',
  GET_LEAGUE_ENTRY = 'GET_LEAGUE_ENTRY',
  GET_ENTRIES = 'GET_ENTRIES',
}
